import { useTranslation } from "react-i18next"
import { observer } from "mobx-react-lite"
import { useStore } from "../../contexts/store"
import ToolSelection from "./Toolbar/ToolSelection"
import ZoomSlider from "./Toolbar/ZoomSlider"
import { Box, Divider } from "@mui/material"
import VisibilitySelection from "./Toolbar/VisibilitySelection"

const PdfFooter = ({pageListRef, storeId}: {pageListRef: any, storeId: string}) => {
  const { t } = useTranslation()
  const { pdfMetaStore } = useStore()
  const numPages = pdfMetaStore.getNumPage(storeId)
  const currentPage = pdfMetaStore.getPageInView(storeId)

  return(
    <Box sx={{display: "grid", gridTemplateColumns: "auto 60px min-content auto", alignItems: "center", borderTop: "1px solid lightgrey", overflow:'hidden'}}>
      {(numPages !== 0 && numPages !== null && currentPage) &&
        <Box sx={{fontSize: "12px", marginLeft: "15px"}}>
          {t('Page {{current}} of {{total}}', {current: currentPage, total: numPages})}
        </Box>
      }
      <Box></Box>
      <Box sx={{
          alignItems: "center",
          display: "grid",
          gridGap: "10px",
          gridTemplateColumns: "min-content min-content",
          justifyContent: "center",
          justifyItems: "center",
          margin: "5px 15px"
        }}>
        <ToolSelection />
      </Box>
      <Box sx={{
          alignItems: "center",
          display: "grid",
          gridGap: "10px",
          gridTemplateColumns: "min-content min-content min-content",
          justifyContent: "end",
          justifyItems: "center",
          margin: "5px 15px"
        }}>
        <VisibilitySelection />
        <Divider orientation="vertical" />
        <ZoomSlider pageListRef={pageListRef} storeId={storeId} />
      </Box>
    </Box>
  )
}

export default observer(PdfFooter)